/*
  EU harmonised notice on the legal guarantee of conformity (Implementing Regulation (EU)
  2025/1960, in force from 27 Sep 2026).

  Every link with [data-mdc-guarantee] (snippets/mdc-guarantee.liquid) opens the official
  notice in a dialog on the first click, as the Commission's practical guidelines describe.
  Where <dialog> isn't supported, or with a modifier key held, the link simply opens
  /pages/garantia-legala, which shows the same notice. Loaded as a module, so it runs once
  per page however many links render it.

  The page behind is scroll-locked in CSS (html:has(dialog.mdc-guarantee[open]), in the
  snippet), so the lock ends whenever the dialog closes, however it was closed.
*/
const MORE_URL = 'https://europa.eu/youreurope/citizens/consumers/shopping/guarantees-returns/index_ro.htm';

/* The notice's own wording, for screen readers (the image carries it visually). */
const NOTICE_TEXT =
  'GARANȚIA LEGALĂ. Protecția oferită de garanția legală minimă de doi ani pentru bunurile vândute în Uniunea Europeană. ' +
  'Consumatorii își pot exercita drepturile în baza garanției legale de conformitate, de exemplu în cazul în care bunurile: ' +
  'nu corespund descrierii; nu funcționează astfel cum a fost prevăzut. ' +
  'Vânzătorii sunt răspunzători pentru orice neconformitate care exista în momentul livrării bunurilor și care este constatată ' +
  'în timpul perioadei de garanție legală. Vânzătorii care se află într-o astfel de situație au obligația să ofere: ' +
  'repararea gratuită sau înlocuirea gratuită a bunului în cauză; în unele cazuri, o reducere de preț sau rambursarea integrală. ' +
  'În unele țări, perioada de garanție legală este mai lungă. Pentru bunurile de ocazie, se poate aplica o perioadă mai scurtă, ' +
  'însă aceasta nu poate fi mai mică de un an. Pentru mai multe informații cu privire la drepturile pe care le aveți ' +
  'într-o anumită țară, scanați codul QR de mai jos sau adresați-vă vânzătorului. europa.eu/youreurope/garanții. ' +
  'Ce puteți face dacă bunurile primite sunt neconforme: 1. contactați-l cât mai curând posibil pe vânzător pentru a-i ' +
  'semnala problema; 2. furnizați o dovadă care să ateste achiziționarea bunului, de exemplu o chitanță, o factură sau ' +
  'un extras de cont. Vânzătorii și producătorii pot oferi și garanții comerciale, care se aplică independent de garanția ' +
  'legală. De exemplu, puteți vedea această etichetă GARAN, care reprezintă o garanție comercială de durabilitate oferită fără ' +
  'costuri suplimentare de către producător și care acoperă întregul bun.';

let dialog = null;
let pressedOnBackdrop = false;

function build(link) {
  dialog = document.createElement('dialog');
  dialog.className = 'mdc mdc-guarantee';
  dialog.setAttribute('aria-labelledby', 'mdc-guarantee-title');
  dialog.innerHTML =
    '<h2 class="mdc-guarantee__title" id="mdc-guarantee-title">Garanția legală – notificarea armonizată a Uniunii Europene</h2>' +
    '<div class="mdc-guarantee__bar">' +
    '<button type="button" class="mdc-guarantee__close" aria-label="Închide">' +
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
    '</button>' +
    '</div>' +
    '<p class="mdc-guarantee__hint">Glisează în lateral ca să vezi toată notificarea.</p>' +
    '<div class="mdc-guarantee__scroll"><img class="mdc-guarantee__img" width="1654" height="2339" decoding="async"></div>' +
    '<p class="mdc-guarantee__more"><a target="_blank" rel="noopener">europa.eu/youreurope/garanții</a></p>' +
    '<div class="mdc-guarantee__sr" id="mdc-guarantee-text"></div>';

  const img = dialog.querySelector('.mdc-guarantee__img');
  img.alt = 'Notificarea armonizată a Uniunii Europene privind garanția legală de conformitate';
  img.setAttribute('aria-describedby', 'mdc-guarantee-text');
  img.sizes = '(max-width: 739px) 700px, 860px';
  if (link.dataset.srcset) img.srcset = link.dataset.srcset;
  img.src = link.dataset.src;

  dialog.querySelector('.mdc-guarantee__more a').href = MORE_URL;
  dialog.querySelector('#mdc-guarantee-text').textContent = NOTICE_TEXT;
  dialog.querySelector('.mdc-guarantee__close').addEventListener('click', () => dialog.close());

  /* A click on the dimmed backdrop lands on the <dialog> itself and closes it - only when the
     press started there too, so selecting text and letting go outside doesn't close it. */
  dialog.addEventListener('pointerdown', (event) => {
    pressedOnBackdrop = event.target === dialog;
  });
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog && pressedOnBackdrop) dialog.close();
    pressedOnBackdrop = false;
  });

  document.body.append(dialog);
}

/* Escape closes the notice, wherever focus is. Handled in the capture phase and marked as
   handled (preventDefault), because the theme's cart drawer also closes on Escape unless
   another component already handled the key - so an open cart stays open behind it. */
document.addEventListener(
  'keydown',
  (event) => {
    if (!dialog || !dialog.open || event.key !== 'Escape' || event.isComposing) return;
    event.preventDefault();
    dialog.close();
  },
  true
);

document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('a[data-mdc-guarantee]') : null;
  if (!link || !link.dataset.src) return;
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (typeof HTMLDialogElement !== 'function') return;

  event.preventDefault();
  if (!dialog) build(link);
  if (!dialog.open) dialog.showModal();
});